class ContentsList extends HTMLElement {
  constructor() {
    super();

    this.articleContentHeadings = document.querySelectorAll(
      "[id^='template-article'] .article-main-content-wrapper .article-content-wrapper h1:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h2:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h3:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h4:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper h5:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h1:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h2:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h3:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h4:not(.card__heading), [id^='template-article'] .article-main-content-wrapper .article-content-wrapper .h5:not(.card__heading)",
    );

    this.addIDToHeadings(this.articleContentHeadings);
    this.populateContentsList(this.articleContentHeadings);
  }

  addIDToHeadings(headings) {
    if (headings) {
      headings.forEach((heading) => {
        heading.id = `article-${heading.innerHTML.toLowerCase().replace("?", "").replace(/\s+/g, "-").replace("<p>", "").replace("</p>", "")}`;

        const link = heading.querySelector("a");
        if (link) {
          heading.id = `article-${link.textContent.toLowerCase().replace("?", "").replace(/\s+/g, "-").replace("<p>", "").replace("</p>", "")}`;
        }
      });
    }
  }

  populateContentsList(headings) {
    if (headings.length > 0) {
      document.querySelector(".contents-list-wrapper").classList.remove("hidden");
      const ul = document.createElement("ul");
      headings.forEach((heading) => {
        const li = document.createElement("li");
        const a = document.createElement("a");
        a.textContent = heading.innerHTML.replace("<p>", "").replace("</p>", "");
        a.href = `#article-${heading.innerHTML.toLowerCase().replace("?", "").replace(/\s+/g, "-").replace("<p>", "").replace("</p>", "")}`;

        // if heading.innerHTML contains a link, get the links inner text and use that as the link text instead
        const link = heading.querySelector("a");
        if (link) {
          a.textContent = link.textContent;
          a.href = `#article-${link.textContent.toLowerCase().replace("?", "").replace(/\s+/g, "-").replace("<p>", "").replace("</p>", "")}`;
        }

        li.appendChild(a);

        a.addEventListener("click", (event) => {
          event.preventDefault();
          const targetId = a.getAttribute("href").substring(1);
          const targetElement = document.getElementById(targetId);
          const headerOffset = document.querySelector(".shopify-section-header-sticky sticky-header.header-wrapper").offsetHeight + 50;
          const elementPosition = targetElement.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        });

        ul.appendChild(li);
      });
      this.appendChild(ul);
    } else {
      document.querySelector(".contents-list-wrapper").classList.add("hidden");
    }
  }
}
customElements.define("contents-list", ContentsList);
